import { useEffect } from 'react'
import { useAuth } from '@/contexts/AuthContext'
import { posthog } from '@/analytics/posthog'

export const PostHogIdentify = () => {
  const { user } = useAuth()

  useEffect(() => {
    if (import.meta.env.PROD) {
      if (user) {
        posthog.identify(user.id, {
          email: user.email,
          user_id: user.id,
        })
      } else {
        posthog.reset()
      }
    }
  }, [user])

  return null
}